





































import Vue from "vue";
import { LicenseDetail } from "@/models/license";
import validationMixin from "@/components/mixins/validationMixin";
import LicenseService from "@/services/licenseService";

export default Vue.extend({
  name: "ChoseLicenseForm",
  mixins: [validationMixin],
  components: {},
  props: ["value"],
  data() {
    return {
      licenses: [] as Array<LicenseDetail>,
      license: this.value,
      loading: false,
    };
  },
  beforeMount() {
    this.loadLicenses();
  },
  watch: {
    value: function (newVal) {
      this.license = newVal;
    },
  },
  methods: {
    async loadLicenses(): Promise<void> {
      try {
        this.loading = true;
        this.licenses = await (
          await LicenseService.get()
        ).filter((license: LicenseDetail) => {
          return license.isRoom || license.isPod;
        });
      } catch (e) {
        this.licenses = [] as Array<LicenseDetail>;
        this.$notification.error(e);
        this.$sentry.capture(e, "wizard", "loadLicenses");
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    isOnPrem(): boolean {
      return this.$store.getters["onprem/isOnPrem"];
    },
  },
});
